import { Button, Modal, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faTools } from "@fortawesome/free-solid-svg-icons";
import ModalProducts from "../../../Components/Modals/ModalProducts";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getSystemSettings } from "../../store/api/SystemSettingsAPI";
import { keyIsLetterOrNumber, setErrorDialog } from "../../../store/api/CommonFunctions";
import ModalSelectCustomer from "../../../Components/Modals/ModalSelectCustomer";
import { Check2, DashCircle, LayoutSidebarReverse, List } from "react-bootstrap-icons";
import { useHistory } from "react-router-dom";
import { saveServiceBatch } from "../../store/api/Services";
import DatePicker from "react-datepicker2";
export default function ModalSaveServiceBatch({ popData, setPopData }) {
    const dispatch = useDispatch();
    const history = useHistory();
    const [submitData, setSubmitData] = useState({});
    const [systemSettings, setSystemSettings] = useState([]);
    const [popProduct, setPopProduct] = useState({ show: false });
    const [popCustomer, setPopCustomer] = useState({ show: false });
    const [isPending, setPending] = useState(false);
    const settingNames = ['ProductGrouppingType'];
    const pgType = Number(systemSettings?.find?.(s => s.SettingName === "ProductGrouppingType")?.SettingValue ?? "1");
    function close() {
        setPopData({ show: false });
    }
    function showModalProduct(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        const setData = (data) => {
            if (data) {
                setSubmitData({ ...submitData, ...data })
            }
        }
        setPopProduct({ show: true, value: e.key, setProductData: setData });
    }
    function showModalCustomer(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        const onSelectCustomer = (data) => {
            if (data) {
                setSubmitData({
                    ...submitData,
                    CustomerID: data.ID,
                    CustomerName: data.Name,
                    CustomerMobile: data.Mobile,
                    CustomerPhone: data.Phone,
                    ServiceAddress: data.Address,
                    Latitude: data.Latitude,
                    ProvinceID: data.ProvinceID,
                    CityID: data.CityID,
                    ZoneID: data.ZoneID,
                    Longitude: data.Longitude,
                    CustomerCode: data.Code
                })
            }
        }
        setPopCustomer({ show: true, value: e.key, invoiceCustomers: false, justforSelect: true, setCustomerData: onSelectCustomer });
    }
    function handleSubmit() {
        if (!submitData?.ServiceType || !submitData?.ProductID || !submitData?.CustomerID || !submitData?.FirstContactDate) {
            return;
        }
        if (!(Number(submitData.ReceptionCount) > 0)) {
            submitData.ReceptionCount = 1;
        }
        setPending(true);
        const onSave = (res) => {
            setPending(false);
            if (res.Error) {
                setErrorDialog(dispatch, res.Error, "ثبت دسته ای پذیرش");
                return;
            }
            setErrorDialog(dispatch, "success", "ثبت دسته ای پذیرش");
            history.push("/Services/myTasks");
        }
        saveServiceBatch(submitData, onSave);
    }
    useEffect(() => {
        if (popData.show) {
            dispatch(getSystemSettings(settingNames, setSystemSettings));
        }
    }, [popData.show])
    return (
        <>
            <ModalProducts popData={popProduct} setProductPopup={setPopProduct} productGrouppingType={pgType} />
            <ModalSelectCustomer popData={popCustomer} setCustomerPopup={setPopCustomer} />
            <Modal show={popData.show}>
                <Modal.Header className="headerStyle">
                    <span>
                        <FontAwesomeIcon icon={faTools} size="lg" />&nbsp;ثبت دسته ای پذیرش
                    </span>
                    <FontAwesomeIcon icon={faTimes} size="lg" onClick={close} />
                </Modal.Header>
                <Modal.Body className="bodyStyle">
                    <Row>
                        <div className="form-group  col-md-3">
                            <label className="ellipsisLabel"><label> نوع پذیرش </label><span style={{ color: "red" }}>*</span></label>
                            <select className="form-control" name="ServiceType" onChange={e => submitData.ServiceType = e.target.value}
                            >
                                <option value="">انتخاب کنید</option>
                                <option value="repair"> تعمیر </option>
                                <option value="install"> نصب </option>
                            </select>
                        </div>
                        <div className="form-group  col-md-5">
                            <label className="ellipsisLabel"> <label> تاریخ و ساعت پذیرش </label><span style={{ color: "red" }}>*</span> </label>
                            <DatePicker popperPlacement="top-start" isGregorian={false} timePicker={true} className="form-control" setTodayOnBlur={false}
                                onChange={value => submitData.FirstContactDate = value.local("en").format("YYYY-MM-DD HH:mm")} />
                        </div>
                        <div className="form-group col-md-4">
                            <label>تعداد پذیرش: </label>
                            <input className="form-control" type="number" onChange={e => submitData.ReceptionCount = e.target.value} defaultValue={1} />
                        </div>
                        <div className="form-group  col-md-6">
                            <label>{pgType === 1 ? ('نام و مدل محصول') : ('مارک، نوع، مدل محصول')} </label><span style={{ color: "red" }}>*</span>
                            <input type="hidden" name="ProductID" readOnly value={submitData?.ProductID ?? ""} />
                            <input type="text" placeholder='محصول را انتخاب کنید' className="form-control"
                                value={[submitData?.HolderName, submitData?.ProductName, submitData?.ProductModel].filter(p => p?.length > 0).join("-")} readOnly />
                            <Button className="btn-input-tiny" onClick={showModalProduct} style={{ marginTop: "-1px" }}><List size={20} /></Button>
                        </div>
                        <div className="form-group  col-md-6">
                            <label style={{ cursor: "pointer" }} >
                                نام و کد مشتری
                            </label><span style={{ color: "red" }}>*</span>

                            <input type="hidden" name="CustomerID" value={submitData?.CustomerID ?? ""} readOnly />
                            <input placeholder='مشتری را انتخاب کنید' type="text" className="form-control"
                                value={submitData.CustomerCode ? submitData.CustomerCode + "-" + submitData.CustomerName : ""} readOnly />
                            <Button className="btn-input-tiny" onClick={showModalCustomer}><List size={20} /></Button>
                        </div>
                        <div className="form-group">
                            <label>توضیحات: </label>
                            <input className="form-control" onChange={e => submitData.Description = e.target.value} />
                        </div>
                        <div className="form-group">
                            <label>نشانی: </label>
                            <input className="form-control" value={submitData?.ServiceAddress ?? ""} onChange={e => setSubmitData({ ...submitData, ServiceAddress: e.target.value })} />
                        </div>
                    </Row>
                    <div className="mt-1">
                        <Button className="group-Btn" variant="success" disabled={isPending} onClick={handleSubmit}><Check2 size={18} /> ثبت اطلاعات</Button>
                        <Button className="group-Btn" variant="danger" onClick={close}><DashCircle size={18} /> انصراف</Button>
                    </div>
                </Modal.Body>
            </Modal></>
    )
}